import type { ProblemDetails } from '../models/problem-details';

/**
 * A failed API call. Carries the status and the problem body so a page can map a specific error
 * code to its own message and let everything else fall through to a generic one.
 */
export class ApiError extends Error {
    constructor(
        readonly status: number,
        readonly problem?: ProblemDetails
    ) {
        super(problem?.detail ?? problem?.title ?? `Request failed with status ${status}`);
        this.name = 'ApiError';
    }

    /** True when the request never reached the server. */
    get isNetworkError(): boolean {
        return this.status === 0;
    }
}
